import { Component } from "react";
import React from "react";
import VerticalLine from "../../shared/components/verticalLineComponent/verticalLine";
import { roadMapElements } from "../../shared/constants/roadmapConstants";
import BackComponent from "../../shared/components/backComponent/back";
import { aboutMe } from "../../shared/constants/generalConstants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row, Col } from "react-bootstrap";
import {
  VerticalTimelineElement,
  VerticalTimeline,
} from "react-vertical-timeline-component";

import "react-vertical-timeline-component/style.min.css";
import "./aboutmeStyle.scss";
class AboutMe extends Component {
  render() {
    return (
      <>
        <div className="page__container">
          <div className="header__wrapper">
            <BackComponent> </BackComponent>{" "}
            <div className="header__title"> about me </div>{" "}
          </div>{" "}
        </div>{" "}
        <div className="aboutme__wrapper">
          <Col
            sm={0}
            md={3}
            lg={3}
            className="aboutme__wrapper__profile__mobile"
          >
            <img
              className="aboutMe__profile-picture"
              src={require("./../../public/images/about_me.jpg")}
              alt="me"
            />
          </Col>{" "}
          <Row>
            <Col
              sm={12}
              md={6}
              lg={6}
              className="aboutMe__profile-description--wrapper"
            >
              <div
                className="aboutMe__profile-description"
                dangerouslySetInnerHTML={{ __html: aboutMe.description }}
              ></div>{" "}
            </Col>{" "}
            <Col
              sm={0}
              md={1}
              lg={1}
              className="aboutMe__profile-verticalLine--wrapper"
            >
              <VerticalLine
                className="aboutMe__profile-verticalLine"
                height={300}
                color={"black"}
                width={5}
              />{" "}
            </Col>{" "}
            <Col
              sm={0}
              md={3}
              lg={3}
              className="aboutme__wrapper__profile__desktop"
            >
              <img
                className="aboutMe__profile-picture"
                src={require("./../../public/images/about_me.jpg")}
                alt="me"
              />
            </Col>{" "}
          </Row>{" "}
        </div>{" "}
        <div className="page__container">
          <span className="header__title"> life roadmap: </span>{" "}
        </div>
        <VerticalTimeline>
          {" "}
          {roadMapElements.map((element) => (
            <VerticalTimelineElement
              className="vertical-timeline-element--work"
              contentStyle={{
                background: "black",
                color: "white",
              }}
              contentArrowStyle={{
                borderRight: "7px solid  rgb(255, 72, 52)",
              }}
              date={element.date}
              dateClassName="vertical-timeline-element--date"
              iconStyle={{
                background: "black",
                color: "#fff",
                paddingLeft: "1px",
                fontSize: "21px",
              }}
              icon={<FontAwesomeIcon icon={element.iconName} />}
              onTimelineElementClick={() =>
                element.onclick && element.onclick()
              }
            >
              <h3 className="vertical-timeline-element-title">
                {element.title}
              </h3>
              <h4 className="vertical-timeline-element-subtitle">
                {element.subtitle}
              </h4>
              {element.description && <p> {element.description} </p>}
            </VerticalTimelineElement>
          ))}
        </VerticalTimeline>
      </>
    );
  }
}

export default AboutMe;
